<div class="energyExportContainer">
  <span class="energyToolWidgetTitle mb-3"> {{ "energy_tool.energy_export.title" | translate }}</span>
  <app-button buttonText="energy_tool.energy_export.btn_label" color="primary" (click)="startExport()"></app-button>
</div>
